import { Observable } from 'rxjs';
import { TuiDataListWrapperModule, TuiSelectModule } from '@taiga-ui/kit';
import { TuiDataListModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { TuiLetModule } from '@taiga-ui/cdk';
import { TranslateModule } from '@ngx-translate/core';
import { Maybe } from '@iss/libs/graphql';
import { FormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';

import { Pagination, PositiveInt } from './paginator.types';

import { PaginatorComponent as BasePaginatorComponent } from '@iss/core/paginator';

@Component({
  selector: 'wo-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: [ './paginator.component.scss' ],
  standalone: true,
  imports: [
    AsyncPipe,
    BasePaginatorComponent,
    FormsModule,
    NgForOf,
    NgIf,
    TranslateModule,
    TuiDataListModule,
    TuiDataListWrapperModule,
    TuiLetModule,
    TuiSelectModule,
    TuiTextfieldControllerModule,
  ],
})
export class PaginatorComponent {
  public readonly pages = [ 10, 20, 50 ];

  @Input() public pagination$!: Observable<Pagination | null>;
  @Input() public totalItems$!: Observable<PositiveInt | null>;
  @Input() public hideOnSinglePage: Maybe<boolean>;
  @Input() public cssClass?: Maybe<string>;
  @Output() public readonly pageChanged = new EventEmitter<PositiveInt>();
  @Output() public readonly sizeChanged = new EventEmitter<PositiveInt>();

  public startIndex({ page, size }: Pagination): PositiveInt {
    return size * (page - 1);
  }

  public endIndex({ page, size }: Pagination, totalItems: PositiveInt): PositiveInt {
    return Math.min(size * page - 1, totalItems - 1);
  }

  public totalPages({ size }: Pagination, totalItems: number): PositiveInt {
    return Math.ceil(totalItems / size);
  }
}
